module.exports = __webpack_public_path__ + "img/landing2-a.0cff9217.jpg";